import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Home, Building2, Check } from "lucide-react";
import { Seo } from "../../components/public/Seo";
import { CtaBand } from "../../components/public/Shared";
import { SERVICES } from "../../data/site";

export default function ServicesOverview() {
  return (
    <>
      <Seo title="Our Services" description="Roof repairs, re-roofing, commercial remedial roofing, gutters, sheeting, skylights, inspections & maintenance across Perth, WA." path="/services" />
      <section className="pt-32 md:pt-44 pb-16 bg-[#224733] text-white relative overflow-hidden wf-grain">
        <div className="absolute -bottom-40 -left-40 w-[500px] h-[500px] rounded-full bg-[#62B848]/15 blur-3xl" />
        <div className="relative max-w-[1400px] mx-auto px-5 md:px-10">
          <p className="text-[#62B848] font-bold tracking-wide uppercase text-sm mb-4">Our services</p>
          <h1 className="font-display font-black tracking-tight text-5xl sm:text-6xl lg:text-7xl leading-none max-w-3xl text-balance">
            Everything above your head, handled.
          </h1>
          <p className="mt-6 text-white/70 text-lg max-w-xl leading-relaxed">
            From a single leak to a full commercial re-roof, West Face covers the lot for homes and property assets across Perth.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-4 py-2 text-sm font-semibold"><Home size={15} className="text-[#62B848]" /> Residential</span>
            <span className="inline-flex items-center gap-2 bg-white/10 border border-white/15 rounded-full px-4 py-2 text-sm font-semibold"><Building2 size={15} className="text-[#62B848]" /> Commercial & large-scale</span>
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 bg-[#F8F9FA]">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid gap-6 md:grid-cols-2">
          {SERVICES.map((s, i) => (
            <motion.div key={s.slug} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }} transition={{ delay: (i % 2) * 0.07 }}>
              <Link to={`/services/${s.slug}`} data-testid={`svc-row-${s.slug}`}
                className="group flex flex-col h-full bg-white rounded-3xl border border-black/5 p-8 shadow-sm hover:shadow-xl hover:-translate-y-1 transition-all duration-300">
                <div className="flex items-start justify-between mb-5">
                  <div className="grid place-items-center w-14 h-14 rounded-2xl bg-[#224733]/8 text-[#224733] group-hover:bg-[#62B848] group-hover:text-white transition-colors">
                    <s.icon size={26} />
                  </div>
                  <div className="flex gap-1.5">
                    {s.forResidential && <span className="text-[10px] font-bold text-[#224733] bg-[#62B848]/15 px-2 py-1 rounded-full">Residential</span>}
                    {s.forCommercial && <span className="text-[10px] font-bold text-white bg-[#224733] px-2 py-1 rounded-full">Commercial</span>}
                  </div>
                </div>
                <h2 className="font-display font-bold text-2xl text-[#1A2421] mb-2 leading-tight">{s.name}</h2>
                <p className="text-[#4A5550] leading-relaxed mb-5 flex-1">{s.blurb}</p>
                <ul className="grid sm:grid-cols-2 gap-2 mb-6">
                  {s.points.slice(0, 4).map((p) => (
                    <li key={p} className="flex items-start gap-2 text-sm text-[#1A2421]"><Check size={15} className="text-[#62B848] mt-0.5 shrink-0" /> {p}</li>
                  ))}
                </ul>
                <span className="inline-flex items-center gap-1 text-[#62B848] font-bold group-hover:gap-2 transition-all">View {s.name} <ArrowRight size={17} /></span>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
